export default "__VITE_ASSET__ffd3d196__"